const updates = [
  { id: 1, date: '07-31', title: '繁花 第29-30集更新上线，大结局抢先看', tag: '剧集更新', tagColor: 'bg-primary-500' },
  { id: 2, date: '07-31', title: '流浪地球3 4K修复版新增杜比音效', tag: '画质升级', tagColor: 'bg-accent-500' },
  { id: 3, date: '07-30', title: '庆余年2 全集已更新完毕，支持一口气追完', tag: '剧集更新', tagColor: 'bg-primary-500' },
  { id: 4, date: '07-30', title: '2024暑期档电影专题页面上线，30+热门影片', tag: '专题上线', tagColor: 'bg-secondary-500' },
  { id: 5, date: '07-29', title: '移动端播放器优化，新增手势调节亮度音量', tag: '功能更新', tagColor: 'bg-accent-500' },
  { id: 6, date: '07-28', title: '三体·动画版 最新话上线，每周五持续更新', tag: '动漫连载', tagColor: 'bg-primary-500' },
  { id: 7, date: '07-27', title: '悬疑片专题「烧脑之夜」上线，20部高分精选', tag: '专题上线', tagColor: 'bg-secondary-500' },
  { id: 8, date: '07-26', title: 'CDN节点新增东南亚线路，海外用户观影更流畅', tag: '服务升级', tagColor: 'bg-accent-500' },
  { id: 9, date: '07-25', title: '纪录片频道改版，新增BBC、国家地理专区', tag: '频道上线', tagColor: 'bg-primary-500' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 mt-1">站点更新公告与内容上线通知</p>
        </div>

        <div className="relative">
          <div className="absolute left-[11px] md:left-[15px] top-2 bottom-2 w-px bg-background-300"></div>

          <div className="space-y-4">
            {updates.map((item) => (
              <div key={item.id} className="relative flex items-start gap-4 md:gap-6 pl-8 md:pl-10">
                <div className={`absolute left-0 md:left-0 top-1 w-[22px] h-[22px] md:w-[30px] md:h-[30px] rounded-full ${item.tagColor} flex items-center justify-center flex-shrink-0 z-10`}>
                  <div className="w-2 h-2 md:w-2.5 md:h-2.5 rounded-full bg-white"></div>
                </div>

                <div className="flex-1 bg-background-100 rounded-xl p-3 md:p-4 cursor-pointer hover:bg-background-200 transition-colors duration-200">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
                    <span className="text-xs font-medium text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className={`px-2 py-0.5 rounded-md text-white text-[10px] font-medium whitespace-nowrap ${item.tagColor}`}>
                      {item.tag}
                    </span>
                    <p className="text-sm text-foreground-800 font-medium">{item.title}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}